import { CatalogCampaignBanner } from '@grupoboticario/barril-del-chavo'
import { Flex } from '@grupoboticario/flora-react'

export type HomeMainBannerProps = {
  catalogSlug: string
}
export const HomeMainBanner = ({ catalogSlug }: HomeMainBannerProps) => {
  return (
    <Flex
      justify="center"
      css={{ width: '100%', height: '100%', maxHeight: '300px' }}
    >
      <CatalogCampaignBanner
        show
        catalogSlug={catalogSlug}
        floraSection="content-top-banner-campaigns"
        css={{ width: '100%' }}
      />
    </Flex>
  )
}
